import { debounceTime, distinctUntilChanged, filter, pluck, switchMap } from 'rxjs/operators'
import { coreApi } from '~/services/core'
import keys from '~/pages/order/order_create.json'
import { empowermentService } from '~/services/EmpowermentService'
import { contractsService } from '~/services/ContractsService'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
  },
  subscriptions() {
    return {
      contracts$: this.searchContract$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`contract/search/number?pattern=${query}`)),
        pluck('data')
      ),
      buyers$: this.searchCompany$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        filter(value => value.length > 2),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
        pluck('data')
      )
    }
  },

  domStreams: ['searchCompany$', 'searchContract$'],

  data: () => ({
    formKeys: keys,
    formTitle: 'ИНФО О ЗАЯВКЕ',
    loading: false,
    //arrays
    buyers: [],
    contracts: [],
    appendixes: [],
    epowerments: [],
    //order
    order: {
      Buyer: {
        Id: null
      },
      Appendix: {
        Id: null
      },
      Empowerment: {
        Id: null
      },
      Contract: {
        Id: null
      },
      Item: null,
      AdditionalInformation: '',
      BuyerCompanyName: '',
      AppendixNumber: '',
      OrderDate: '',
      ContactPhone: '',
      ContractNumber: '',
      DeliveryAddress: '',
      Number: '',
      Status: '',
      Total: 0
    }
  }),
  methods: {
    calculateDensity(density) {
      const result = this.order.ClosedAmountInTonne * this.order.Density
      let res = parseFloat(result).toFixed(4)
      if (isNaN(res)) {
        res = 0
      }
      this.order.GrossPerTonne = res
    },

    resetAll(canBuyer = true) {
      if (canBuyer) {
        this.buyer = {}
      }
      this.order.Item = null
      this.contracts = []
      this.appendixes = []
      this.epowerments = []
    },
  },
  watch: {

    //arrays
    async 'order.Buyer'(buyer) {
      if (typeof (buyer) !== 'object' || buyer?.Id == null) return
      if (!buyer) return
      const id = buyer.Id
      if (id) {
        const empowers = await empowermentService.getCompanyById({ companyId: id })
        this.epowerments = await empowers.data || []
        const contracts = await contractsService.contractCompanyById({ companyId: id })
        this.contracts = contracts.data || []
      }
    },

    async 'order.Contract'(contract) {
      if (!contract) return
      this.order.Buyer = { ...contract.Buyer }
      this.order.ContractNumber = contract.Number
      this.appendixes = contract.Appendixes || []
    },

    buyers(buyers) {
      this.formKeys['Buyer.Id'].attrs.items = buyers || []
      this.buyers$ = buyers
    },

    contracts(contracts) {
      this.formKeys['Contract.Id'].attrs.items = contracts || []
      this.contracts$ = contracts
    },

    appendixes(appendixes) {
      this.formKeys['Appendix.Id'].attrs.items = appendixes || []
    },

    epowerments(epowerments) {
      this.formKeys['Empowerment.Id'].attrs.items = epowerments || []
    }


  }


}